@if(loading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Cargando usuarios'"></app-loader>
  </div>
}

<div class="p-6" *ngIf="!loading">
  <!-- Toolbar -->
  <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
    <p-iconfield>
      <p-inputicon styleClass="pi pi-search" />
      <input pInputText type="text" [(ngModel)]="globalFilter" placeholder="Buscar usuario..." class="w-72" />
    </p-iconfield>
    @if(data.UserType === 'Administrator') {
      <button pButton label="Nuevo Usuario" icon="pi pi-plus" class="p-button-sm" (click)="newUser()"></button>
    }
  </div>

  <!-- Desktop Table -->
  <div class="hidden md:block">
  <p-table [value]="response.items" [paginator]="response.items.length > 10" [rows]="10" [rowsPerPageOptions]="[10, 30, 50]"
    [globalFilterFields]="['name','email','phone','accessType']" styleClass="p-datatable-sm p-datatable-striped"
    [scrollable]="true" scrollHeight="flex"
    [showCurrentPageReport]="true" [currentPageReportTemplate]="'Mostrando {first} a {last} de {totalRecords}'">
    <ng-template #header>
      <tr>
        <th class="w-[50px]"></th>
        @for(col of tableColumns; track col.key) {
          <th [pSortableColumn]="col.key">{{ col.header }} <p-sortIcon [field]="col.key" /></th>
        }
        <th>Estado</th>
        @if(data.UserType === 'Administrator' || data.UserType === 'Modify') {
          <th class="w-[220px] text-center">Acciones</th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-user>
      <tr>
        <td>
          <app-avatar [name]="user.name || user.email" size="sm" />
        </td>
        @for(col of tableColumns; track col.key) {
          <td>
            @if(col.key === 'phone') {
              <div class="flex items-center gap-1.5">
                <img [src]="user[col.key]?.startsWith('+1') ? './assets/icons/united-states-flag-icon.svg' : './assets/icons/mexico-flag-icon.svg'" class="h-3.5 w-5" />
                <span>{{ user[col.key]?.split(' ')[1] || user[col.key] }}</span>
              </div>
            } @else {
              {{ user[col.key] }}
            }
          </td>
        }
        <td>
          <span class="px-2 py-1 rounded-full text-xs font-semibold"
            [ngClass]="isActive(user) ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'">
            {{ isActive(user) ? 'Activo' : 'Pendiente' }}
          </span>
        </td>
        @if(data.UserType === 'Administrator' || data.UserType === 'Modify') {
          <td class="text-center">
            <div class="flex justify-center gap-1">
              @if(data.UserType === 'Administrator') {
                @if(isActive(user)) {
                  <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm" pTooltip="Editar" (click)="showInfoUser(user)"></button>
                  <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text p-button-sm" pTooltip="Eliminar" (click)="confirmDeleteUser(user)"></button>
                  <button pButton icon="pi pi-key" class="p-button-rounded p-button-text p-button-sm" pTooltip="Contraseña" (click)="confirmSendResetLink(user)"></button>
                  <button pButton icon="pi pi-link" class="p-button-rounded p-button-text p-button-sm" pTooltip="Asignar dispositivos" (click)="selectDevices(user)"></button>
                  @if(user.accessType === 'Modificación') {
                    <button pButton [icon]="user.canActivate ? 'pi pi-check-circle' : 'pi pi-ban'"
                      class="p-button-rounded p-button-text p-button-sm"
                      [ngClass]="user.canActivate ? 'text-green-500' : 'text-gray-400'"
                      pTooltip="Activar/Desactivar aprobación" (click)="activateUser(user)"></button>
                  }
                } @else {
                  <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm" pTooltip="Editar" (click)="showInfoUser(user)"></button>
                  <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text p-button-sm" pTooltip="Eliminar" (click)="confirmDeleteUser(user)"></button>
                  <button pButton icon="pi pi-key" class="p-button-rounded p-button-text p-button-sm" pTooltip="Contraseña" (click)="confirmSendResetLink(user)"></button>
                  <button pButton icon="pi pi-envelope" class="p-button-rounded p-button-text p-button-sm" pTooltip="Reenviar activación" (click)="resend(user)"></button>
                }
              }
              @if(data.UserType === 'Modify') {
                <button pButton icon="pi pi-link" class="p-button-rounded p-button-text p-button-sm" pTooltip="Asignar dispositivos" (click)="selectDevices(user)"></button>
              }
            </div>
          </td>
        }
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr><td [attr.colspan]="10" class="text-center py-8 text-vivid-royal-400">No hay usuarios por visualizar</td></tr>
    </ng-template>
  </p-table>
  </div>

  <!-- Mobile Cards -->
  <div class="md:hidden space-y-3">
    @if(response.items.length === 0) {
      <p class="text-center py-8 text-vivid-royal-400">No hay usuarios por visualizar</p>
    }
    @for(user of response.items; track user.userId) {
      <div class="bg-white dark:bg-crayola-blue-800 rounded-lg shadow-sm p-4 space-y-2">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <app-avatar [name]="user.name || user.email" size="sm" />
            <span class="font-bold text-vivid-royal-800 dark:text-white">{{ user.name }}</span>
          </div>
          <span class="px-2 py-0.5 rounded-full text-xs font-semibold"
            [ngClass]="isActive(user) ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'">
            {{ isActive(user) ? 'Activo' : 'Pendiente' }}
          </span>
        </div>
        <div class="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
          <div class="text-vivid-royal-400">Correo</div>
          <div class="text-right text-vivid-royal-900 dark:text-white truncate">{{ user.email }}</div>
          <div class="text-vivid-royal-400">Teléfono</div>
          <div class="text-right text-vivid-royal-900 dark:text-white">
            <img [src]="user.phone?.startsWith('+1') ? './assets/icons/united-states-flag-icon.svg' : './assets/icons/mexico-flag-icon.svg'" class="h-3 w-4 inline mr-1" />
            {{ user.phone?.split(' ')[1] || user.phone }}
          </div>
          <div class="text-vivid-royal-400">Acceso</div>
          <div class="text-right text-vivid-royal-900 dark:text-white">{{ user.accessType }}</div>
        </div>
        @if(data.UserType === 'Administrator') {
          <div class="flex flex-wrap gap-2 pt-2 border-t border-dark-khaki-200 dark:border-vivid-royal-700">
            <button pButton icon="pi pi-pencil" label="Editar" class="p-button-sm p-button-outlined" (click)="showInfoUser(user)"></button>
            <button pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-outlined" (click)="confirmDeleteUser(user)"></button>
            <button pButton icon="pi pi-key" label="Contraseña" class="p-button-sm p-button-outlined" (click)="confirmSendResetLink(user)"></button>
            <button pButton icon="pi pi-link" label="Dispositivos" class="p-button-sm p-button-outlined" (click)="selectDevices(user)"></button>
            @if(!isActive(user)) {
              <button pButton icon="pi pi-envelope" label="Reenviar" class="p-button-sm p-button-outlined" (click)="resend(user)"></button>
            }
          </div>
        }
        @if(data.UserType === 'Modify') {
          <div class="flex gap-2 pt-2 border-t border-dark-khaki-200 dark:border-vivid-royal-700">
            <button pButton icon="pi pi-link" label="Dispositivos" class="p-button-sm p-button-outlined" (click)="selectDevices(user)"></button>
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- Delete confirm -->
<p-dialog header="Confirmar eliminación" [(visible)]="showDeleteConfirm" [modal]="true" [style]="{width: '400px'}">
  <p class="text-sm">¿Desea eliminar al usuario <b>{{ deleteTarget?.name || deleteTarget?.email }}</b>?</p>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showDeleteConfirm=false"></button>
    <button pButton label="Eliminar" class="p-button-danger" icon="pi pi-trash" (click)="doDeleteUser()"></button>
  </ng-template>
</p-dialog>


<!-- Reset password confirm -->
<p-dialog header="Enviar link de cambio de contraseña" [(visible)]="showResetConfirm" [modal]="true" [style]="{width: '430px'}">
  <p class="text-sm">Se enviará un correo a <b>{{ resetTarget?.email }}</b> con un enlace para restablecer su contraseña. ¿Desea continuar?</p>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showResetConfirm=false"></button>
    <button pButton label="Enviar" class="p-button-sm" icon="pi pi-send" (click)="doSendResetLink()"></button>
  </ng-template>
</p-dialog>
<!-- Existing modals -->
<app-user-modal *ngIf="showModal" [inProcess]="false" [isNewUser]="isNewUser" [elements]="response.items"
  [message]="msgModal" [userData]="userData" (onConfirm)="onConfirm()" (onCancel)="onCancel()"
  (msgModalAlert)="onToastSuccess($event)"></app-user-modal>


<app-device-modal *ngIf="showModalDevice" (onCancel)="showModalDevice=false" [deviceData]="deviceData"
  [cardsClient]="cardsClient" (deviceDataChange)="updateDevices($event)"></app-device-modal>
